export { default as SelectTable } from './SelectTable';

export const Types = { SELECT_TABLE: 'SELECT_TABLE' };
